export default {
    getPreguntas() {
        return new Promise((resolve, reject) => {
            let ruta = `/api/preguntas`;
            return axios.get(ruta).then((response) => {
                resolve(response.data)
            }, response => {
                resolve(response.data)
            });
        })
    }
}